import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/ui/Button.jsx'
import { useFeedback } from '../../../components/ui/feedback.jsx'
import api from '../../../lib/api.js'

/* Step 2 — logo (skippable). POST /companies/:id/logo only if changed. */
const MAX = 2 * 1024 * 1024
export default function StepLogo({ companyId, bindSubmit }) {
  const { t } = useTranslation()
  const { notify } = useFeedback()
  const fileRef = useRef(null)
  const [preview, setPreview] = useState(null)
  const [dataUrl, setDataUrl] = useState(null)

  useEffect(() => { api.get(`/companies/${companyId}`).then(({ data }) => setPreview((data?.company || data)?.logo_url || null)) }, [companyId])
  useEffect(() => {
    bindSubmit(async () => {
      if (!dataUrl) return true
      try { await api.post(`/companies/${companyId}/logo`, { logo: dataUrl }) } catch { /* optional */ }
      return true
    })
  }, [dataUrl, companyId, bindSubmit])

  const onFile = (e) => {
    const file = e.target.files?.[0]; if (!file) return
    if (!/image\/(png|jpe?g)/.test(file.type)) { notify({ tone: 'error', title: t('settings.error'), message: t('settings.company.logoFormat') }); return }
    if (file.size > MAX) { notify({ tone: 'error', title: t('settings.error'), message: t('setup.steps.logo.tooBig') }); return }
    const reader = new FileReader()
    reader.onload = () => { setDataUrl(reader.result); setPreview(reader.result) }
    reader.readAsDataURL(file)
  }

  return (
    <>
      <p style={{ color: 'var(--color-text)', fontSize: 14, marginBottom: 18 }}>{t('setup.steps.logo.intro')}</p>
      <div style={{ height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--color-bg-lilac)', borderRadius: 12, marginBottom: 14 }}>
        {preview ? <img src={preview} alt="logo" style={{ maxHeight: 110, maxWidth: '90%', objectFit: 'contain' }} /> : <span style={{ color: 'var(--color-text-muted)', fontSize: 13 }}>{t('settings.company.noLogo')}</span>}
      </div>
      <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/jpg" onChange={onFile} style={{ display: 'none' }} />
      <Button variant="secondary" icon="download" onClick={() => fileRef.current?.click()}>{t('settings.company.changeLogo')}</Button>
    </>
  )
}
